const formValidate = {
    phone: function(rule, value, callback) {
        if(!value){
            callback(new Error('请输入手机号码'));
        }else if (!(/^1[123456789]\d{9}$/.test(value))) {
            callback(new Error('手机号码有误，请重填'));
        } else {
            callback();
        }
    },

    email: function(rule, value, callback) {
        var email = value;
        var reg = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        if (reg.test(email)) {
            callback();
        } else {
            callback(new Error('邮箱格式不正确'));
        }
    },
    realName: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入姓名'));
        }
    },
    matTypes: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('选择物料类型'));
        }
    },
    unitCode: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请选择单位'));
        }
    },
    planName: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入方案名称'));
        }
    },
    planCode: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入方案编号'));
        }
    },
    matName: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入物料名称'));
        }
    },
    qualityManager: function(rule, value, callback) {
        if (value) {
            callback();
        } else if (value == 0) {
            callback();
        } else {
            callback(new Error('请输入物料名称'));

        }
    },
    eqpName: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入设备名称'));
        }
    },
    eqpType: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请选择设备类型'));
        }
    },
    eqpSm: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入规格型号'));
        }
    },
    projectName: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入项目名称'));
        }
    },
    minValue: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入最低标称值'));
        }
    },
    maxValue: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入最高标称值'));
        }
    },
    sprName: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入供应商名称'));
        }
    },
    sprCode: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请选择供应商'));
        }
    },
    whName: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入名称'));
        }
    },
    whCode: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入编号'));
        }
    },
    titleName: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入标题'));
        }
    },
    parentWhCode: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请选择上级仓位'));
        }
    },
    configCode: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入配置编号'));
        }
    },
    upkMethod: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入保养办法'));
        }
    },
    troubleReason: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入故障原因'));
        }
    },
    assetCode: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入资产编号'));
        }
    },
    troubleName: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入常见故障'));
        }
    },
    prodCode: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入生产指令'));
        }
    },
    qualityDepId: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请选择质检部门'));
        }
    },
    prodOrderCode: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入产品编号'));
        }
    },
    planOutput: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入计划产量'));
        }
    },
    problemName: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入质检问题'));
        }
    },
    problemCode: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入问题编号'));
        }
    },
    problemType: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请选择分类'));
        }
    },
    troubleType: function(rule, value, callback) {
        if (value) {
            callback();
        } else if (value == 0) {
            callback();
        } else {
            callback(new Error('请选择故障现象'));
        }
    },
    repairMethod: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入维修方法'));
        }
    },
    troubleReason: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入故障原因'));
        }
    },
    freqType: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请选择理论周期'));
        }
    },
    actionList: function(rule, value, callback) {
        if (value) {
            callback();
        } else if (value == 0) {
            callback();

        } else {
            callback(new Error('请选择角色或人'));
        }
    },
    eqpCode: function(rule, value, callback) {
        if (value) {
            callback();
        } else if (value == 0) {
            callback();

        } else {
            callback(new Error('请选择适用设备'));
        }
    },
    date: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请选择日期'));
        }
    },
    expirationCount: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请输入质保年限'));
        }
    },
    eqpFrom: function(rule, value, callback) {
        if (value) {
            callback();
        } else if (value == 0) {
            callback();

        } else {
            callback(new Error('请选择设备来源'));
        }
    },
    actionUser: function(rule, value, callback) {
        if (value) {
            callback();
        } else if (value == 0) {
            callback();

        } else {
            callback(new Error('请选择提交人'));
        }
    },
    actionDate: function(rule, value, callback) {
        if (value) {
            callback();
        } else {
            callback(new Error('请选择提交时间'));
        }
    },
    contactsEmail: function(rule, value, callback) {
        var email = value;
        var reg = /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
        if (value) {
            if (reg.test(email)) {
                callback();
            } else {
                callback(new Error('邮箱格式不正确'));
            }
        } else {
            callback();
        }

    },
};

export default formValidate;